import type { SavedReply } from '../hooks/useSavedReplies';

type HasDuplicateReplyTitleOptions = {
  title: string;
  savedReplies: Array<SavedReply | null>;
  excludeReplyIndex?: number; // When editing, exclude current reply
};

export default function hasDuplicateReplyTitle({
  title,
  savedReplies,
  excludeReplyIndex,
}: HasDuplicateReplyTitleOptions): boolean {
  const normalizedTitle = title.trim().toLowerCase();
  if (!normalizedTitle) return false;

  return savedReplies.some((reply) => {
    if (!reply) return false;

    // When editing, exclude the current reply from duplicate check
    if (excludeReplyIndex !== undefined && reply.replyIndex === excludeReplyIndex) {
      return false;
    }

    return reply.title.toLowerCase().trim() === normalizedTitle;
  });
}
